import { useCallback, useEffect, useState } from 'react';
import { Collapse, Container, DropdownItem, DropdownMenu, Nav, NavItem, Navbar, NavLink, NavbarBrand, NavbarToggler, DropdownToggle, Dropdown } from 'reactstrap';
import { IPageInfo, Pages } from '../models/Constants';
import * as DOM from 'react-router-dom';
import { LoginItem } from './helpers/LoginLogout';
import { ContactUsItem } from './ContactUsItem';
import { useRouteLoaderData } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from '@azure/msal-react';
import { apiRequest } from '../util/api';
import { useAuth } from '../util/Auth';

export const HeaderSection: React.FC = () => {
	const { navbar } = useRouteLoaderData("root") as { navbar: IPageInfo[] };
	const [isOpen, setIsOpen] = useState(false);
	const toggle = useCallback(() => setIsOpen(!isOpen), [setIsOpen, isOpen]);
	const { instance, accounts } = useMsal();
	const [isCubeConOrganizer, setIsCubeConOrganizer] = useState(false);

	//todo move to server for config
	const navItems = [
		Pages.CubeCon,
		...navbar,
		//Pages.Shop,
		Pages.Cubes,
		Pages.Gallery,
		Pages.FAQ,
		Pages.About,
	];

	useEffect(() => {
		if (!accounts || accounts.length === 0) {
			setIsCubeConOrganizer(false);
			return;
		};
		apiRequest('admin', undefined, accounts[0].idToken).then(response => setIsCubeConOrganizer((response === "true"))); //We love Javascript don't we folks
	}, [setIsCubeConOrganizer, isCubeConOrganizer, instance, accounts]);

	return <div className="bg-dark"><Container><Navbar color="dark" dark expand="md" className="test">
		<NavbarBrand tag={DOM.Link} to={"/"}><img className="imageFit iconSmall" src="/assets/cubeconHeaderWithDate.png" alt="Cubecon Icon" style={{ maxWidth: "100%" }} /></NavbarBrand>
		<NavbarToggler onClick={toggle} />
		<Collapse isOpen={isOpen} navbar>
			<Nav navbar>
				{navItems.map(page => <TabNavItem key={page.title} page={page} />)}
				<ContactUsItem />
				<AdminDropdown />
				<LoginItem />
			</Nav>
		</Collapse>
	</Navbar></Container></div>;
};

export const AdminDropdown = () => {
	const isAuthenticated = useIsAuthenticated();
	const { onSuccess } = useAuth(false);
	const [isAdmin, setIsAdmin] = useState(false);
	const [dropdownOpen, setDropdownOpen] = useState(false);

	onSuccess((tokenResponse) =>
		apiRequest("admincheck", "", tokenResponse.idToken).then((response) => {
			if (response?.isAdmin) {
				setIsAdmin(true);
			};
		}
		));

	if (!isAuthenticated || !isAdmin) {
		return null;
	}

	return <Dropdown isOpen={dropdownOpen} onMouseOver={() => setDropdownOpen(true)} onMouseOut={() => setDropdownOpen(false)} toggle={() => {}} className="navDropdown ccNavItem">
		<DropdownToggle nav caret>Admin</DropdownToggle>
		<DropdownMenu dark>
			<DropdownItem tag={DOM.NavLink} to={"/admin/submissions"}>Review Submissions</DropdownItem>
			<DropdownItem tag={DOM.NavLink} to={"/admin/cubes/2026"}>Cubes</DropdownItem>
			<DropdownItem tag={DOM.NavLink} to={'/admin/polls'}>Edit Polls</DropdownItem>
		</DropdownMenu>
	</Dropdown>
}

interface TabNavItemProps {
	page: IPageInfo;
}

//this looks silly right now but eventually I want to have a way to toggle pages on or off instead of editing the Header section
const TabNavItem = (props: TabNavItemProps) => {
	const { page } = props;
	const [dropdownOpen, setDropdownOpen] = useState(false);

	if (page.subPages?.length ?? 0 > 1) {
		return <Dropdown nav inNavbar isOpen={dropdownOpen} onMouseOver={() => setDropdownOpen(true)} onMouseOut={() => setDropdownOpen(false)} toggle={() => {}} className="navDropdown ccNavItem">
			<DropdownToggle nav caret tag={DOM.NavLink} to={page.href}>{page.title}</DropdownToggle>
			<DropdownMenu dark>
				{page.subPages?.map(subPage => <DropdownItem key={subPage.href} tag={DOM.NavLink} to={subPage.href} disabled={subPage.disabled}>{subPage.title}</DropdownItem>)}
			</DropdownMenu>
		</Dropdown>;
	}
	else {
		return <NavItem>
			<NavLink tag={DOM.NavLink} to={page.href} className="ccNavItem">{page.title}</NavLink>
		</NavItem>;
	}
};